// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"483711bd","492":"e16bfe48"}[chunkId] + ".chunk.js";
};